/**
 * Shady Rays - Store Availability & Inventory Tool
 * Version: 2.7.8 (2.7.4 + nativeFetch bypasses tbyb wrap on inventory call)
 */

(function() {
    const nativeFetch = window.fetch.bind(window);

    const ELIGIBLE_STATES = ['KY', 'TN', 'IN', 'CO', 'AZ', 'MN'];
    const IPINFO_TOKEN = '1f1d77b02f7251';

    const STORE_LOCATION_MATCHERS = {
        nashville: ['franklin store', 'franklin'],
        minneapolis: ['mall of america', 'bloomington'],
        indianapolis: ['noblesville store', 'noblesville'],
        scottsdale: ['scottsdale store', 'scottsdale'],
        denver: ['denver store', 'denver', 'lone tree', 'park meadows'],
        lexington: ['lexington store', 'lexington'],
        louisville: ['louisville store'],
    };
    STORE_LOCATION_MATCHERS['pigeon-forge'] = ['pigeon forge store', 'pigeon forge'];

    function matchInventoryForStore(store, invData) {
        const keys = STORE_LOCATION_MATCHERS[store.id] || [store.name.toLowerCase()];
        const rows = invData.data || [];
        for (let i = 0; i < rows.length; i++) {
            const loc = (rows[i].node?.location?.name || '').toLowerCase();
            if (loc.includes('bulk') || loc.includes('corporate') || loc.includes('innovation way')) continue;
            if (!keys.some(k => loc.includes(k))) continue;
            const qty = rows[i].node?.quantities?.[0]?.quantity;
            if (typeof qty === 'number') return qty;
        }
        return 0;
    }

    async function getConvertData() {
        let attempts = 0;
        while (attempts < 15) { 
            const cv = window.convert || (window.parent && window.parent.convert);
            let state = cv?.getUserData?.()?.geo?.state || cv?.currentData?.geo?.state || cv?.currentData?.geo?.region_code;
            if (state) return state;
            await new Promise(r => setTimeout(r, 150));
            attempts++;
        }
        return null;
    }

    async function initBopisTrigger() {
        if (/bot|spider|crawl|slurp|ia_archiver|messenger|facebook|whatsapp/i.test(navigator.userAgent)) return;
        const triggerBtn = document.querySelector('.sr-bopis-trigger');
        const wrapper = document.querySelector('.sr-bopis-wrapper');
        if (!triggerBtn) return;

        let userState = localStorage.getItem('sr_user_state');
        if (userState === 'NON-ELIGIBLE' || userState === 'NON-US') {
            if (wrapper) wrapper.style.display = 'none';
            return;
        }

        if (userState && userState !== "undefined") {
            processEligibility(userState, triggerBtn);
            return;
        }

        const rawState = await getConvertData();
        if (rawState) {
            const statesMap = { 'kentucky':'KY', 'tennessee':'TN', 'indiana':'IN', 'colorado':'CO', 'arizona':'AZ', 'minnesota':'MN' };
            userState = statesMap[rawState.toLowerCase()] || rawState;
        }

        if (!userState) {
            try {
                const locRes = await fetch(`https://ipinfo.io/json?token=${IPINFO_TOKEN}`, { signal: AbortSignal.timeout(3000) });
                const locData = await locRes.json();
                userState = locData.region_code || locData.region; 
                if (locData.loc) {
                    const [lat, lon] = locData.loc.split(',');
                    localStorage.setItem('sr_user_coords', JSON.stringify({ lat: parseFloat(lat), lon: parseFloat(lon) }));
                }
            } catch (e) {}
        }

        if (userState) {
            localStorage.setItem('sr_user_state', userState);
            processEligibility(userState, triggerBtn);
        }
    }

    function processEligibility(state, btn) {
        const stateCodes = { "Kentucky":"KY", "Tennessee":"TN", "Indiana":"IN", "Colorado":"CO", "Arizona":"AZ", "Minnesota":"MN" };
        const cleanState = stateCodes[state] || state;
        const isEligible = ELIGIBLE_STATES.includes(cleanState);
        if (isEligible) {
            if (btn.closest('.sr-bopis-wrapper')) btn.closest('.sr-bopis-wrapper').style.display = 'block';
            btn.style.display = 'block';
        } else {
            localStorage.setItem('sr_user_state', 'NON-ELIGIBLE');
            if (btn.closest('.sr-bopis-wrapper')) btn.closest('.sr-bopis-wrapper').style.display = 'none';
        }
    }

    window.openStoreModal = async function(variantId, productId) {
        const modal = document.getElementById('sr_bopis_modal');
        const content = document.getElementById('sr_bopis_content');
        const storeDataEl = document.getElementById('sr_store_data');
        if (!modal || !content || !storeDataEl) return;

        const storeInfo = JSON.parse(storeDataEl.textContent);
        const coords = JSON.parse(localStorage.getItem('sr_user_coords'));
        
        document.body.style.overflow = 'hidden';
        modal.onclose = () => { document.body.style.overflow = ''; };
        modal.showModal();

        let stores = storeInfo.stores.map(s => {
            let distance = (coords?.lat && s.lat) ? calculateDistance(coords.lat, coords.lon, s.lat, s.lng) : Infinity;
            return { ...s, distance, statusText: "Checking...", statusClass: "sr-status-checking" };
        }).sort((a, b) => a.distance - b.distance);

        renderStoreList(stores, content, true); 

        try {
            const invRes = await nativeFetch(`https://protect.shadyrays.com/api/inventory/${productId}/${variantId}`, {
                method: 'GET',
                headers: { 'Authorization': window.srInventoryToken }
            });

            if (!invRes.ok) throw new Error('API Error');
            const invData = await invRes.json();

            const finalData = stores.map(store => {
                const qty = matchInventoryForStore(store, invData);
                let statusText = "In Stock", statusClass = "sr-status-in";
                if (qty <= 0) { statusText = "Out of Stock"; statusClass = "sr-status-out"; }
                else if (qty <= 5) { statusText = "Limited Stock"; statusClass = "sr-status-limited"; }
                return { ...store, statusText, statusClass };
            });

            renderStoreList(finalData, content, true);
        } catch (err) {
            renderStoreList(stores.map(s => ({ ...s, statusText: "Contact Store", statusClass: "sr-status-unknown" })), content, true);
        }
    };

    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 3958.8; 
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2) * Math.sin(dLon/2);
        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)));
    }

    function renderStoreList(stores, container, isFinal = false) {
        container.innerHTML = stores.map((store, index) => {
            const sClass = store.statusClass;
            const sText = store.statusText;
            const isNearest = index === 0 && store.distance !== Infinity;
            return `
            <div class="sr-store-row">
                <div class="sr-store-main" onclick="this.closest('.sr-store-row').classList.toggle('is-open')">
                    <div class="sr-store-left">
                        <div class="sr-store-name-row"><span class="sr-store-name">${store.name}</span>${isNearest ? '<span class="sr-geo-badge">Nearest</span>' : ''}</div>
                        <span class="sr-store-address">${store.address}</span>
                    </div>
                    <div class="sr-store-right"><span class="sr-stock-status ${sClass}">${sText}</span><span class="sr-chevron"></span></div>
                </div>
                <div class="sr-details-wrapper"><div class="sr-details-inner">
                    <div class="sr-info-grid">
                        <div class="sr-info-item"><strong>Phone</strong><br><a href="tel:${store.phone}">${store.phone || 'N/A'}</a></div>
                        <div class="sr-info-item"><strong>Hours</strong><br>${store.hours}</div>
                    </div>
                    <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(store.address)}" target="_blank" aria-label="page (opens in a new tab)" class="sr-directions-link">Get Directions</a>
                </div></div>
            </div>`;
        }).join('');
    }

    document.addEventListener('change', (e) => {
        if (e.target.name === 'id' || e.target.closest('.product-form__input')) {
            const btn = document.querySelector('.sr-bopis-trigger');
            if (btn) {
                const match = btn.getAttribute('onclick')?.match(/'([^']*)', '([^']*)'/);
                if (match && match[2]) btn.setAttribute('onclick', `window.openStoreModal('${e.target.value}', '${match[2]}')`);
            }
        }
    });

    const initShield = () => {
        setTimeout(initBopisTrigger, 2000);
        ['mousemove', 'touchstart', 'scroll'].forEach(ev => window.removeEventListener(ev, initShield));
    };
    ['mousemove', 'touchstart', 'scroll'].forEach(ev => window.addEventListener(ev, initShield, { once: true }));
})();